import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import pusrf1 from './imgs/grlpfp.png';
import pusrm1 from './imgs/boypfp.png';
import {cleardv} from './clearmem';
import {clrwidgate,insertpost,showhidediv,msgalw,entervilla,loadwidgate} from './userdefaultdata';
import Useractivities from './Useractivities';
import notif from './imgs/blb1.gif';
import msgimg from './imgs/posting.png';
import Girlspfp from './Girlspics';
import Boyspfp from './Boyspics';
import {configpvtmsg} from './Userpmgs';
import { getmessage} from './Dynamictable';

export const Uprofile = (row:any) => {
  function closepfp(){
    clrwidgate('usrwidgt');
	//cleardv('profiledivtop');

   }  
 function closeact(){
    //clrwidgate('usrwidgt');
	//cleardv('profiledivtop');
 	showhidediv(false,'profiledivtop');
           showhidediv(true,'activitymenu');

   }
     
 function showItem(){
   	loadwidgate('wigtarea',12);

	showhidediv(true,'chattypedivtop');

   }
function giftshoping(e:any,id:any){
 	Usersession.setIsgifted(id);
	loadwidgate('wigtarea',10);
	showhidediv(true,'chattypedivtop');
        //alert(id);
}

       return(
<div className="per100">	
<div id="profiledivtop" className="per100">
 	<div style={{height:'auto',width:'100%'}}>  
 	    <div className="search-title-bar">
                       	<div style={{width:'20%'}} className="search-title">
			  Profile
			</div>
                       <a href="#" onClick={e=>activity(e,row.uid,row.isf)} title="Act">
			<div className="action-button" id="Useractivity">
                          
			 <img src={notif} style={{height:'20px',width:'20px'}} />

			</div>

			</a>
			<a href="#" onClick={e=>sendmsg(e,row)} title="Act">
			<div className="action-button" id="Usermsg">
                          
			 <img src={msgimg} style={{height:'20px',width:'20px'}} />

			</div>

			</a>

			<a href="#" onClick={closepfp} title="Profile">
			<div className="search-title-toggle" id="togglesearch">
			  X
			</div>
			</a>
	    </div>
	</div>
        <div className="c-pfp-line-u">

	<div id="pfpimg"  className="c-frofile-img">
         {row.utf?(
	  <Girlspfp  itemid={row.pfpid} wth={'75px'}  hgt={'7vh'}/>

	 ):(
	<Boyspfp  itemid={row.pfpid} wth={'75px'}  hgt={'7vh'}/>

	)}
         {row.utf?(
         <div className="c-pfp-tp">Female<span></span></div>
	 ):(
	<div className="c-pfp-tp">Male<span></span></div>
	)}

	</div>
       <div className="cu-user-nm-info">
        	<div id="username"  className="c-user-name">
	 	<span style={{width:'auto'}}>{row.uname}</span>
                <a href="#" onClick={e=>restrecteduser(e,row.uid)} title="Restricted">
		<span id="userrestriction" className="userrestrict">X</span>
                </a>					
        	</div>
        	<div id="userpoint" style={{display:'none'}}  className="c-user-point">
			<span> Points: </span><span id="pointcnt"></span>
        	</div>
	</div>
   </div>	

        
	
    
    
     <div className="c-info-line">
       <div className="c-frofile-litem">
	
        <span>
        <a href="#" className="blanka"  onClick={e=>addfrnd(e,row.uid,row.uname)} title="Villa" >
	<span style={{backgroundColor:'#7d6ab2'}} className="item-count" id="addfdriend">Add friend</span>
        </a>
	</span>
       </div>
      </div>  
      <div className="c-info-line">
       <div className="c-frofile-litem">
       	<a href="#" className="blanka" onClick={showItem} title="Items">
		<span style={{backgroundColor:'#7d6ab2'}} className="item-count">Items</span>
        </a>
        <a href="#" className="blanka" onClick={e=>giftshoping(e,row.uid)} title="Gift">
	      <span style={{backgroundColor:'#7d6ab2'}} className="item-count" id="giftitem">Gift</span>
	</a>
       </div>
      </div>  
     </div>

 <div id="activitymenu" style={{display:'none',zIndex:'35000'}} className="cu-frofile-u">
	   <div style={{height:'auto',width:'100%'}}>  
 	    <div className="search-title-bar">
                       	<div className="search-title">
			  Activities
			</div>
                       
			<a href="#" onClick={closeact} title="Activity">
			<div className="search-title-toggle" id="closeactivity">
			  X
			</div>
			</a>
	    </div>
            <div id="uactlist" style={{height:'32vh',overflowY:'auto'}}>
		<Useractivities />
	    </div>	
	</div>
	</div>  
    </div>
    );


};
 export const  addfrnd=(e:any,id:any,nm:any)=>{
  if(id){
        //alert(id);
        let Unm = ''; 
	const userid = Usersession.getUserId();
	const objuser = Usersession.getUserpfp();
	const pfid = objuser.pfpid;
	const utp = objuser.utf;
	const name = objuser.uname;
	const txt ='Please accept my Requested';
	const clrcode = Usersession.getColorcode();
        if(nm)Unm = nm;
	//alert(utp);
	//alert(ruisrid);

	const apimsgurl = '/insertfrndrqst';

	const fu = utp?'0':'1';

        const obj = {sendid:userid,receiveid:id,message:Unm,pfpid:pfid,ccd:clrcode,isf:fu,insert:'1'};

	insertpost(apimsgurl,obj);

  }
}
 export const  activity=(e:any,id:any,fm:any)=>{
  if(id){
       // alert(id);
         showhidediv(true,'profiledivtop');
           showhidediv(false,'activitymenu');
        let Unm = ''; 
	const userid = Usersession.getUserId();
	const objuser = Usersession.getUserpfp();
	const pfid = objuser.pfpid;
	const utp = objuser.utf;
	const name = objuser.uname;
	const txt ='Please accept my Requested';
	const clrcode = Usersession.getColorcode();
        //if(nm)Unm = "";
	//alert(userid);
	//alert(ruisrid);

	const apimsgurl = '/insertfrndrqst';

	const fu = utp?'0':'1';

        const obj = {sendid:userid,receiveid:id,message:Unm,pfpid:pfid,ccd:clrcode,isf:fu,insert:'1'};

	//insertpost(apimsgurl,obj);

  }
}

 export const  sendmsg=(e:any,row:any)=>{
  if(row){
       // alert(JSON.stringify(row));
        const uid = Usersession.getUserId();

        const userid = row.uid;
        const cod = row.ccod;
        const isf = row.utf?"1":"0";
        const pfpid = row.pfpid;
        const nm = row.uname; 
       const msgalwid = row.msgalow;
      //alert(msgalwid);
      const isalow = msgalw(uid,userid,msgalwid);
      if(isalow=="OK"){ 
      const arr = [[{uid:userid,mpfpid:pfpid,utf:isf,unm:nm,unrmsgs:0,mccd:cod,misread:"0"}]]
      // alert(JSON.stringify(arr))
      configpvtmsg(arr,userid);
      }else{
	getmessage(isalow,'');

       }	
          

  }
}

export const  restrecteduser=(e:any,restrictedid:any)=>{
  const vtpid =  Usersession.getVillatype();

  if(restrictedid){
      if(vtpid == '2'){
	const ownerid = Usersession.getUserId();
	const villaid = Usersession.getVillaId();
       const vname = Usersession.getVillaname();

	const apimsgurl = '/insertvlarestriction';
        const obj = {ownrid:ownerid,vlid:villaid,userid:restrictedid};
       
	insertpost(apimsgurl,obj);
         const vlid = villaid;

      entervilla(villaid,vname,vlid,'2');
    }
    else{
      getmessage('No restriction of Public villa','');

    } 

  }
}
